import React, { useState } from "react";
// Using Translate Library
import { FormattedMessage, useIntl } from "react-intl";
// Using Material UI Components
import {
  Grid,
  TextField,
  Button,
  IconButton,
  Tooltip,
  Popover,
  Typography,
  FormHelperText,
  MuiThemeProvider,
  createMuiTheme,
  makeStyles,
  InputLabel,
  LinearProgress,
} from "@material-ui/core";

import bg from "../../../images/bg-logo.jpg";
import { DoubleArrow, ArrowBack } from "@material-ui/icons";
// Using Utilities Functionalities
import { classes } from "../../../utils/styledClasses";
import { STEPS, countryCodes } from "../../../utils/constants";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { useHistory, useLocation } from "react-router-dom";

const theme = createMuiTheme({
  palette: {
    secondary: {
      main: "rgb(100, 38, 187)",
    },
  },
});
const useStyle = makeStyles({
  inputStyle: {
    width: "350px",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#215CA8",
      },
    },
  },
  phoneContainer: {
    width: "350px",
  },
  label: {},
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
});
const InstitutionRegistryQuestions = ({
  person,
  formik,
  setRegistrationStep,
  handleSubmit,
}) => {
  console.log("[INSTITUTION REGISTRY DEBUG] Component initialized", {
    personName: `${person?.name} ${person?.surname} ${person?.patronymic}`,
    structureName: person?.structureData?.structureName,
    positionName: person?.structureData?.positionName,
    hasFormik: !!formik,
    formikValues: formik?.values
  });
  const history = useHistory();
  const intl = useIntl();
  const classMaterial = useStyle();

  return (
    <div className="card card-custom card-stretch gutter-b">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          console.log("[INSTITUTION REGISTRY DEBUG] Form submitted", {
            nationality: formik.values?.nationality,
            personInChargeName: formik.values?.personInChargeName,
            personInChargePhone: formik.values?.personInChargePhone,
            personInChargeEmail: formik.values?.personInChargeEmail,
            hasErrors: Object.keys(formik.errors).length > 0,
            errors: formik.errors
          });
          handleSubmit(e);
        }}
      >
        <div className="card-header border-0">
          <div className="d-flex align-items-center w-100">
            <img src={bg} alt="" />
          </div>
        </div>

        <div className="d-flex gutter-b justify-content-end font-weight-normal text-muted gutter-b mr-11 ml-11">
          <>
            <FormattedMessage id="evaluated_Institution" />
            {" : "}
            <span
              style={{
                backgroundColor: "#17c191",
                padding: "0 5px",
                border: "1px solid #17c191",
                borderRadius: 4,
                margin: "0 5px",
                color: "white",
                fontWeight: 400,
              }}
            >
              {person?.structureData?.structureName}
            </span>
          </>
        </div>
        <div className="card-body pt-5">
          <Grid container spacing={2} justify="center">
            <Grid md={5} style={classes.rowStyles} alignItems="center">
              <TextField
                id="outlined-basic"
                label={`${intl.formatMessage({
                  id: "reg_input_nationality",
                })}*`}
                size="small"
                variant="outlined"
                name="nationality"
                className={classMaterial.inputStyle}
                value={formik.values?.nationality}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                error={Boolean(
                  formik.touched?.nationality && formik.errors?.nationality
                )}
                helperText={
                  formik.touched?.nationality && formik.errors?.nationality
                }
              />
            </Grid>
            <Grid md={5} style={classes.rowStyles} alignItems="center">
              <TextField
                type="text"
                size="small"
                variant="outlined"
                id="outlined-basic"
                label="Səlahiyyətli şəxsin adı soyadı ata adı*"
                disabled={true}
                name="personInChargeName"
                defaultValue={`${person?.name} ${person?.surname} ${person?.patronymic}`}
                value={formik.values?.personInChargeName}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                className={classMaterial.inputStyle}
                error={Boolean(
                  formik.touched?.personInChargeName &&
                    formik.errors?.personInChargeName
                )}
                helperText={
                  formik.touched?.personInChargeName &&
                  formik.errors?.personInChargeName
                }
              />
            </Grid>
            <Grid md={5} style={classes.rowStyles} alignItems="center">
              <TextField
                type="text"
                size="small"
                variant="outlined"
                id="outlined-basic"
                label={`${intl.formatMessage({
                  id: "personInChargePosition*",
                })}`}
                disabled={true}
                name="personInChargePosition"
                value={person.structureData.positionName}
                onChange={formik.handleChange}
                className={classMaterial.inputStyle}
                error={Boolean(
                  formik.touched?.personInChargePosition &&
                    formik.errors?.personInChargePosition
                )}
                helperText={
                  formik.touched?.personInChargePosition &&
                  formik.errors?.personInChargePosition
                }
              />
            </Grid>
            <Grid md={5} style={classes.rowStyles} alignItems="center">
              <PhoneInput
                containerClass={`{MuiFormControl-root MuiTextField-root ${classMaterial.phoneContainer}`}
                inputStyle={{
                  alignItems: "center",
                  width: "350px",
                  padding: "10px 14px 8px 50px",
                  alignItems: "center",
                  marginBottom: 2,
                  fontSize: 14,
                  height: 40,
                  borderRadius: 4,
                  borderColor:
                    formik.touched?.personInChargePhone &&
                    formik.errors?.personInChargePhone
                      ? "#f018a6"
                      : "#215CA8",
                  color:
                    formik.touched?.personInChargePhone &&
                    formik.errors?.personInChargePhone
                      ? "#f018a6"
                      : null,
                }}
                name="personInChargePhone"
                countryCodeEditable={false}
                enableAreaCodes={true}
                masks={{ az: "(..) ... .. .." }}
                country={"az"}
                onlyCountries={countryCodes.map((c) => c.toLowerCase())}
                onBlur={() => {
                  formik.handleBlur({
                    target: { name: "personInChargePhone" },
                  });
                }}
                value={formik.values?.personInChargePhone}
                onChange={(e) => {
                  formik.setFieldValue("personInChargePhone", e);
                }}
                specialLabel={
                  formik.touched?.personInChargePhone &&
                  formik.errors?.personInChargePhone ? (
                    <div style={{ color: "#f018a6" }}>
                      Səlahiyyətli şəxsin əlaqə nömrəsi*
                    </div>
                  ) : (
                    <div style={{ color: "#000000" }}>
                      Səlahiyyətli şəxsin əlaqə nömrəsi*
                    </div>
                  )
                }
              />
              {formik.touched?.personInChargePhone && (
                <FormHelperText style={{ color: "#f018a6" }}>
                  {formik.errors?.personInChargePhone}
                </FormHelperText>
              )}
            </Grid>

            <Grid md={5} style={{ ...classes.rowStyles, marginTop: "2px" }}>
              <TextField
                type="email"
                size="small"
                variant="outlined"
                id="outlined-basic"
                label={<FormattedMessage id="header.personInChargeEmail*" />}
                name="personInChargeEmail"
                value={formik.values?.personInChargeEmail}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                className={classMaterial.inputStyle}
                error={Boolean(
                  formik.touched?.personInChargeEmail &&
                    formik.errors?.personInChargeEmail
                )}
                helperText={
                  formik.touched?.personInChargeEmail &&
                  formik.errors?.personInChargeEmail
                }
              />
            </Grid>
            <Grid md={5} style={classes.rowStyles} alignItems="center"></Grid>
            <div
              className="d-flex justify-content-center"
              style={{ marginTop: "55px", width: "100%" }}
            >
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/izYTVYXicZc"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              ></iframe>
            </div>
            <div
              className="card-toolbar d-flex justify-content-between mt-8"
              style={classes.vw_100}
            >
              <MuiThemeProvider theme={theme}>
                <Button
                  style={{ textTransform: "capitalize" }}
                  variant="outlined"
                  color="default"
                  size="small"
                  onClick={() =>
                    person?.active
                      ? history.goBack()
                      : setRegistrationStep(STEPS.INDUSTRY_CHOICE)
                  }
                  startIcon={<ArrowBack />}
                >
                  <FormattedMessage id="button.back" />
                </Button>
                <Button
                  type="submit"
                  style={{
                    backgroundColor: "rgb(100, 38, 187)",
                    textTransform: "capitalize",
                    width: "160px",
                    color: "#fff",
                    height: "45px",
                    marginLeft: "10px",
                  }}
                  variant="contained"
                  color="secondary"
                  size="small"
                  endIcon={<DoubleArrow />}
                >
                  <FormattedMessage id="button.submit" />
                </Button>
              </MuiThemeProvider>
            </div>
          </Grid>
        </div>
      </form>
    </div>
  );
};

export default InstitutionRegistryQuestions;
